export default __webpack_public_path__ + "static/media/stage-2-gain-setting-nuclei.f1768e68.png";